module.exports = __webpack_public_path__ + "static/img/plan-task_00.e4aacf38.png";